import {IInformationDetenu} from './information-detenu.model';
import {IInformationVisiteur} from './information-visiteur.model';
import {IPieceJustificative} from './piece-justificative.model';

export interface IMajDemandePermisVisiteSortiParcours {
    id?: number;
    demandePersonnelle?: boolean;
    numeroEtape?: number;
    informationDetenu?: IInformationDetenu | null;
    informationVisiteur?: IInformationVisiteur | null;
    pieceJustificatives?: IPieceJustificative[] | null;
}

export class MajDemandePermisVisiteSortiParcours implements IMajDemandePermisVisiteSortiParcours {

    constructor(
        public id?: number,
        public demandePersonnelle?: boolean,
        public numeroEtape?: number,
        public informationDetenu?: IInformationDetenu | null,
        public informationVisiteur?: IInformationVisiteur | null,
        public pieceJustificatives?: IPieceJustificative[] | null,
    ) {
    }
}
